import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import {FormGroup} from "@angular/forms";
import {AskInput} from "./askInput";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";

@Component({
    selector: 'app-ask-input',
    templateUrl: './ask-input.component.html',
    styleUrls: ['./ask-input.component.scss']
})
export class AskInputComponent extends NodeBuilder implements OnInit {

    askInputForm: FormGroup;

    constructor() {
        super("askInput");
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: any) {
        this.askInputForm = AskInput.toForm(stepData, this.canEdit);
        if (this.askInputForm.get('next').value === newStepValue) {
            this.askInputForm.get('next').setValue('step' + this.getNextStep());
        }
    }

    get getStepData(): {} {
        const nodeData: AskInput = new AskInput();
        nodeData.setNodeData(this.askInputForm.getRawValue())
        return nodeData.nodeData;
    }

    get isNodeValid(): boolean {
        this.askInputForm.markAllAsTouched();
        return this.askInputForm.valid;
    }
}
